export default __webpack_public_path__ + "static/media/flipbook-pagetype-home.23863df1.svg";